import React, { useEffect, useState } from "react";
import "../modal-base.css";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../../context/AuthContext";
import {
    getBranchWorkingDays,
    updateBranchWorkingDays,
    deleteWorkingDay,
} from "../../../services/branch-workingday";
import DynamicTable from "../../Table/Table";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";

const dayLabels = {
    Sunday: "الأحد",
    Monday: "الاثنين",
    Tuesday: "الثلاثاء",
    Wednesday: "الأربعاء",
    Thursday: "الخميس",
    Friday: "الجمعة",
    Saturday: "السبت",
};

export default function BranchDetailsModal({ branchId, onClose }) {
    const { token } = useAuth();
    const [workingDays, setWorkingDays] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [pendingDeleteId, setPendingDeleteId] = useState(null);
    const [tempIdCounter, setTempIdCounter] = useState(-1);

    const fetchWorkingDays = async () => {
        setLoading(true);
        try {
            const res = await getBranchWorkingDays(token, branchId);
            setWorkingDays(res.data.workingDays);
        } catch (err) {
            console.error("فشل تحميل أيام الدوام", err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (branchId) fetchWorkingDays();
    }, [branchId]);

    const formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [hours, minutes] = timeStr.split(":");
        return `${hours}:${minutes}`;
    };

    const handleSave = async (id, newRow) => {
        try {
            const cleaned = workingDays.filter((d, index, self) =>
                index === self.findIndex((t) => t.id === d.id)
            );
            const updated = cleaned.map((d) => (d.id === id ? newRow : d));
            const res = await updateBranchWorkingDays(token, branchId, updated);
            setWorkingDays(res.data);
            setEditId(null);
        } catch (err) {
            alert("حدث خطأ أثناء الحفظ");
            console.error(err);
        }
    };

    const handleDelete = (row) => {
        setPendingDeleteId(row.id);
        setShowConfirmDelete(true);
    };

    const confirmDelete = async () => {
        try {
            if (pendingDeleteId < 0) {
                setWorkingDays((prev) => prev.filter((d) => d.id !== pendingDeleteId));
            } else {
                await deleteWorkingDay(token, pendingDeleteId);
                setWorkingDays((prev) => prev.filter((d) => d.id !== pendingDeleteId));
            }
            setEditId(null);
        } catch (err) {
            console.error("فشل حذف اليوم", err);
            alert("حدث خطأ أثناء الحذف");
        } finally {
            setShowConfirmDelete(false);
            setPendingDeleteId(null);
        }
    };

    const columns = [
        {
            key: "dayName",
            label: "اليوم",
            isDropdown: true,
            options: Object.keys(dayLabels).map((key) => ({ value: key, label: dayLabels[key] })),
            render: (row) => dayLabels[row.dayName] || row.dayName,
        },
        {
            key: "startTime",
            label: "من",
            isTime: true,
            render: (row) => (row.isClosed ? "-" : formatTime(row.startTime)),
        },
        {
            key: "endTime",
            label: "إلى",
            isTime: true,
            render: (row) => (row.isClosed ? "-" : formatTime(row.endTime)),
        },
        {
            key: "isClosed",
            label: "الحالة",
            isDropdown: true,
            options: [
                { value: true, label: "مغلق" },
                { value: false, label: "يعمل" },
            ],
            render: (row) => (row.isClosed ? "مغلق" : "يعمل"),
        },
    ];

    return (
        <div className="modal-backdrop">
            <div className="modal-box" style={{ width: "800px", maxWidth: "90%" }} dir="rtl">
                <button className="modal-close" onClick={onClose}>×</button>
                <h2 className="text-lg font-bold mb-4">مواعيد الدوام</h2>

                {loading ? (
                    <div className="loading-container">
                        <CircularProgress />
                    </div>
                ) : (
                    <DynamicTable
                        data={workingDays}
                        columns={columns}
                        loading={false}
                        onSave={handleSave}
                        onDelete={handleDelete}
                        onAdd={(setRecentlyAddedId) => {
                            const remainingDays = Object.keys(dayLabels).filter(
                                (day) => !workingDays.some((d) => d.dayName === day)
                            );
                            if (remainingDays.length === 0) return alert("تمت إضافة جميع الأيام مسبقًا");

                            const newDay = {
                                id: tempIdCounter,
                                dayName: remainingDays[0],
                                startTime: "08:00",
                                endTime: "16:00",
                                isClosed: false,
                            };
                            setWorkingDays((prev) => [...prev, newDay]);
                            setEditId(tempIdCounter);
                            setTempIdCounter((prev) => prev - 1);
                            setRecentlyAddedId(tempIdCounter);
                        }}
                        onEdit={() => {}}
                        editId={editId}
                        setEditId={setEditId}
                        showDetailsColumn={false}
                        editableColumns={["dayName", "isClosed", "startTime", "endTime"]}
                    />
                )}

                {showConfirmDelete && (
                    <ConfirmationModal
                        message="هل أنت متأكد من حذف هذا اليوم؟"
                        handleConfirm={confirmDelete}
                        onClose={() => setShowConfirmDelete(false)}
                    />
                )}
            </div>
        </div>
    );
}
